import { render, staticRenderFns } from "./modal-forgot-password.vue?vue&type=template&id=d64733a0&scoped=true"
import script from "./modal-forgot-password.vue?vue&type=script&lang=js"
export * from "./modal-forgot-password.vue?vue&type=script&lang=js"
import style0 from "./modal-forgot-password.vue?vue&type=style&index=0&id=d64733a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64733a0",
  null
  
)

export default component.exports